// extracted by mini-css-extract-plugin
export default {"Registration":"incidentreport_Registration__pqpbz","Title":"incidentreport_Title__a6+-0"};